
export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-10 h-10 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-lg flex items-center justify-center">
                <i className="ri-presentation-line text-white text-lg"></i>
              </div>
              <h3 className="text-xl font-bold">天建产业服务</h3>
            </div>
            <p className="text-gray-400 mb-6">
              专业的外贸财税合规解决方案提供商，助力企业在新政环境下实现合规发展。
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer">
                <i className="ri-linkedin-line text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer">
                <i className="ri-mail-line text-xl"></i>
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-6">解决方案</h4>
            <ul className="space-y-3">
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">0110一般贸易出口</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">1039市场采购贸易</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">香港转口贸易</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">税务筹划</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-6">服务支持</h4>
            <ul className="space-y-3">
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">政策解读</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">合规咨询</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">风险评估</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">培训服务</a></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <p className="text-gray-400 text-sm">
              © 2025 天建产业服务. 保留所有权利.
            </p>
            <div className="flex items-center space-x-6 mt-4 md:mt-0">
              <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">隐私政策</a>
              <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">服务条款</a>
              <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">Made with Readdy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
